import React, { useEffect, useRef, useState } from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { StackableModal } from '../components/nextgen';
import useModal from '../hooks/useModal';

const DeleteModal = () => {
	const { open, setClose } = useModal('deleteModal');
	const [form, setForm] = useState({});
	const [isConfirming, setIsConfirming] = useState(false);
	const cancelButtonRef = useRef(null);

	useEffect(() => {
		if (open) {
			setForm(open?.defaultForm || {});
			setIsConfirming(false);
		}
	}, [open]);

	return (
		<StackableModal
			open={!!open}
			onClose={() => setClose()}
			size="lg"
			showCloseIcon={false}
			initialFocusRef={cancelButtonRef}
		>
			<div className="sm:flex sm:items-start mb-5">
				<div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
					<ExclamationTriangleIcon
						className="h-6 w-6 text-red-600"
						aria-hidden="true"
					/>
				</div>
				<div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left flex-1">
					<h3 className="text-lg font-medium leading-6 text-gray-900">
						{open?.title}
					</h3>
					<div className="mt-2">
						<p className="text-sm text-gray-500">
							{typeof open?.description === 'function'
								? open?.description(form, setForm)
								: open?.description}
							{typeof open?.form === 'function'
								? open?.form(form, setForm)
								: null}
						</p>
					</div>
				</div>
			</div>
			<div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
				<button
					type="button"
					disabled={isConfirming}
					className="inline-flex w-full justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
					onClick={async () => {
						setIsConfirming(true);
						try {
							await open?.onConfirm(form);
						} finally {
							setIsConfirming(false);
							setClose();
						}
					}}
				>
					{isConfirming ? 'Deleting...' : open?.confirmText}
				</button>
				<button
					type="button"
					className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:w-auto sm:text-sm"
					onClick={() => (open?.onCancel ? open?.onCancel() : setClose())}
					ref={cancelButtonRef}
				>
					{open?.cancelText || 'Cancel'}
				</button>
			</div>
		</StackableModal>
	);
};

export default DeleteModal;
